export default __webpack_public_path__ + "img/Montserrat-Regular_3db65dc.woff";